<template>
  <v-container>
    <!-- <button @click="getPlans">getplans</button> -->
    <v-layout row wrap>
      <!-- <v-flex xs6 sm3>
        <v-card :to="{name: 'plandetail', params: {guid: ''}}">
          <v-card-title>
            <div class="heading">Opprett ny plan</div>
          </v-card-title>
        </v-card>
      </v-flex>-->
      <template v-for="plan in plans" v-if="plan.deleted == 0">
        <v-flex :key="plan.id" xs6 sm3 class="planwrapper">
          <v-card
            :class="{ success: plan.active }"
            :to="{ name: 'plandetail', params: { guid: plan.id } }"
          >
            <v-card-title>
              <div v-html="plan.title"></div>
            </v-card-title>
            <v-card-text>
              <div v-html="plan.year"></div>
            </v-card-text>
          </v-card>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      plans: [],
    };
  },
  methods: {
    ...mapActions(["GET_PLANS"]),
    getPlans() {
      this.GET_PLANS()
        .then((res) => {
          this.plans = res.data.planning;

          if (this.plans.length == 1) {
            this.$router.push({
              name: "plandetail",
              params: { guid: this.plans[0].id },
            });
          } else {
            // var _FindActive = this.plans.find((el) => el.active == 1);
            // if (_FindActive) {
            //   this.$router.push({
            //     name: "plandetail",
            //     params: { guid: _FindActive.id },
            //   });
            // }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
  mounted() {
    this.getPlans();
  },
};
</script>

<style></style>
